import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'iot-platform-ui-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  @Input() display: boolean;

  constructor() {}

  ngOnInit() {}
}
